<app-filter [filterType]="state === 'sent' ? 'checkbox' : ''"
  [checkboxFilterText]="'show_expired_quotation' | i18next"
  (checkboxFilterChanged)="showExpired($event)"
  (searchFilterChanged)="doFilter($event)"
[placeholder]="'search_orders' | i18next"></app-filter>

@if (state === 'sent') {
  <div class="p-3">
    <div class="alert alert-warning border shadow-sm" role="alert">
      {{ 'order_phone_number_price_hint' | i18next }}
    </div>
  </div>
}

<div class="row align-items-stretch mt-2">
  @for (order of orders; track order) {
    <app-order-card
      class="col-xs-12 col-md-6 col-lg-6 mb-3"
      [state]="state"
      [order]="order"
      (refresh)="onRefresh()"
      [ngClass]="order.attachment ? 'hover-effect' : ''">
    </app-order-card>
  }
</div>

@if (!orders || orders.length === 0) {
  <div class="row mt2 red card-h1">
    <div class="col">
      <span>{{'no_orders' | i18next}}</span>
    </div>
  </div>
}

@if (orders && needsPagination) {
  <div class="d-flex justify-content-center mb-3">
    <button (click)="nextPage()" name="load-more-orders"
    class="btn btn-outline-primary">{{ 'order_load_more_button' | i18next }}</button>
  </div>
}
